<nb-card  *appPermissionCheck="ComponentPermission.COMPANY_LIST">
  <nb-card-header>
    Company Management
  </nb-card-header>
  <nb-card-body>
    <ng2-smart-table [settings]="settings"
                     [source]="source"
                     (delete)="deleteRecord($event)"
                     (edit)="editRecord($event)"
                     (create)="addRecord($event)">
    </ng2-smart-table>
  </nb-card-body>
</nb-card>
